// agGridStateLocalStorageMiddleware.ts
import type { Middleware } from "@reduxjs/toolkit";
import { rSetAgGridState, rResetFiltersInAg, rClearAgGridState } from "./agGridStateSlice";

const LS_KEY = "agGrid.byKey.v1";

const hasLS = () => typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const agGridLocalStorageMiddleware: Middleware = (store) => (next) => (action) => {
  const res = next(action);

  if (!hasLS()) return res;

  if (
    rSetAgGridState.match(action) ||
    rResetFiltersInAg.match(action) ||
    rClearAgGridState.match(action)
  ) {
    try {
      const data = store.getState().agGrid.byKey; // <-- rätt nyckel
      window.localStorage.setItem(LS_KEY, JSON.stringify(data));
    } catch {
      // ignore LS errors
    }
  }
  return res;
};

export function loadAgGridStateFromLS() {
  try {
    if (!hasLS()) return undefined;
    const raw = window.localStorage.getItem(LS_KEY);
    if (!raw) return undefined;
    const byKey = JSON.parse(raw);
    return { agGrid: { byKey } }; // <-- matchar din reducer-nyckel
  } catch {
    return undefined;
  }
}
